// Layout.js
import React from 'react';
import MLHome from '../images/ML_alfa_500.png';
import MinistereHome from '../images/Ministere_extraido_500.png';

import './Footer.css'; 

const HomeFooter = () => {


  return (
    <div footer-home>
        <div className='grid-footer-container-home'>
          <div className='grid-item-logo-home logoML' id='grid1-logo-home'>
          <img src={MLHome} alt="ML" className='footer-logo' />

          </div>
          
          <div className='grid-item-logo-home ' id='grid2-logo-home'>
           <img src={MinistereHome} alt="Ministere" />
 
          </div>
          <div className='grid-item-logo-home text-link' id='grid3-logo-home'>
          Le projet "En bonne entente dans le quartier de Bonnevoie" est proposé par Luxembourg multi-LEARN Institute asbl et réalisé avec le soutien du Ministère de la Famille, des Solidarités, du Vivre ensemble et de l'Accueil. <br></br> 
          Plus d'information : <a className='link-ml' href='https://multi-learn.org/'target="_blank" rel="noopener noreferrer">www.multi-learn.org</a>

          </div>


        </div>
       
     {/*   </footer>*/}
    </div>
  );
};

export default HomeFooter;